import { ticketInputs } from '../../constants';

export type ContentPropsT = {
	handleForceUpdate: (forceUpdate: boolean) => void;
	onClose: () => void;
	createTicket: (filtersData: ticketInputs) => Promise<{
		rowCount: number;
		data: any;
	}>;
};

export const FORM_FIELD_KEYS = {
	SUBJECT: 'subject',
	DESCRIPTION: 'description',
	TOPIC_NAME: 'topicName',
	SUB_TOPIC_NAME: 'subTopicName',
	TRANSACTION_ID: 'transactionId',
	ENTRY_FEE: 'entryFee'
};
